import React, {useState} from 'react';
import {
  LoginFormTitle,
  LoginFormWrapper,
  SubmitBtn,
  StyledAuthInput,
  StyledAuthFormItem,
  PasswordLabelWrapper,
  ForgotFormWrapper,
  ErrorLine,
  ErrorText,
  BackImageWrapper,
} from './styles';
import {Form, Select} from 'antd';
import {useLoginRes} from '../../hooks/auth';
import {Link} from 'react-router-dom';
import {EmailResultLine, ResultText} from '../Forgot/styles';
import {isMobile} from '../../ui-kit/theme/breakpoints';
import BackImage from '../../ui-kit/AppLayout/assets/trees.png';
import styled from 'styled-components';
import {EyeInvisibleOutlined, EyeOutlined} from '@ant-design/icons';

type LoginFormProps = {
  authData: useLoginRes;
  successUpdated?: boolean;
};

const validateMessages = {
  types: {
    email: 'Invalid email. Please enter a valid email.',
    password: 'Invalid password. Please enter a valid password.',
  },
};

const LoginFormForgot: React.FC = () => {
  return <Link to="/forgot-password">Forgot password</Link>;
};

export const PasswordLabel: React.FC = () => {
  return (
    <>
      {isMobile && <span>Password</span>}
      <ForgotFormWrapper>
        <LoginFormForgot />
      </ForgotFormWrapper>
    </>
  );
};

const options = [
  {label: 'Enchant & Classic', value: 'enc'},
  {label: 'Jingle', value: 'jingle'},
];
export const LoginForm: React.FC<LoginFormProps> = ({authData, successUpdated}) => {
  const {onSubmit, error, resetError} = authData;
  const [form] = Form.useForm();
  const [pv, setPV] = useState(false);
  const togglePV = () => setPV((prev) => !prev);

  const onFinish = (values: any) => {
    onSubmit(values);
  };
  return (
    <LoginFormWrapper
      form={form}
      onFinish={onFinish}
      onChange={resetError}
      validateMessages={validateMessages}
      layout={'vertical'}>
      <LoginFormTitle>Admin Login</LoginFormTitle>
      <StyledAuthFormItem
        label={isMobile ? '' : 'Brand'}
        name={['brand']}
        rules={[{required: true, message: 'Brand is required!'}]}>
        <StyledSelect options={options} placeholder="Select Brand" />
      </StyledAuthFormItem>
      <StyledAuthFormItem
        label={isMobile ? '' : 'Email Address'}
        name={['email']}
        rules={[
          {required: true, message: 'Email Address is required!'},
          {
            type: 'email',
          },
        ]}>
        <StyledAuthInput placeholder="Enter email" />
      </StyledAuthFormItem>
      <PasswordWrapper>
        <StyledAuthFormItem
          label={
            !isMobile ? (
              <PasswordLabelWrapper>
                <PasswordLabel />
              </PasswordLabelWrapper>
            ) : (
              ''
            )
          }
          rules={[{required: true, message: 'Password is required!'}]}
          name={['password']}>
          <StyledAuthInput type={pv ? 'text' : 'password'} placeholder="Enter password" />
        </StyledAuthFormItem>
        <VisibleIcon onClick={togglePV}>{pv ? <EyeInvisibleOutlined /> : <EyeOutlined />}</VisibleIcon>
      </PasswordWrapper>

      {isMobile && (
        <ForgotFormWrapper>
          <LoginFormForgot />
        </ForgotFormWrapper>
      )}
      {error && (
        <ErrorLine>
          <ErrorText>{error}</ErrorText>
        </ErrorLine>
      )}
      <StyledAuthFormItem>
        <SubmitBtn htmlType="submit" loading={authData.loading}>
          Log in
        </SubmitBtn>
      </StyledAuthFormItem>
      {successUpdated && (
        <EmailResultLine>
          <ResultText>Success, your password has been updated.</ResultText>
        </EmailResultLine>
      )}
      {isMobile && (
        <BackImageWrapper>
          <img src={BackImage} />
        </BackImageWrapper>
      )}
    </LoginFormWrapper>
  );
};

const PasswordWrapper = styled.div`
  position: relative;
`;

const VisibleIcon = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  right: 10px;
  bottom: 5px;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    box-shadow: none;
    border-radius: 4px !important;
  }
  &.ant-select-status-error .ant-select-selector {
    border: 1px solid ${({theme}) => theme.palette.common.brown} !important;
  }
  .ant-select-item-option {
    background-color: transparent;
  }
`;
